import { Box, Grid, Modal } from "@mui/material";
import React, { useEffect, useState } from "react";
import CoreInput from "../../core/inputs/CoreInput";
import CoreButtonContainer from "../../core/layouts/CoreButtonContainer";
import CoreButton from "../../core/inputs/CoreButton";
import {
  API_METHOD_GET,
  API_METHOD_POST,
  ENTITY_STATUS,
} from "../../config/constants";
import { useDispatch, useSelector } from "react-redux";
import { api_request } from "../../store/actions/commonAction";
import {
  FETCH_TABLE_DATA_SEARCH_SUCCESS,
  INSERT_TABLE_DATA_ERROR,
  INSERT_TABLE_DATA_SUCCESS,
} from "../../store/types/manageDataTypes";
import CoreJsonEditor from "../../core/inputs/CoreJsonEditor";
import CoreAutoComplete from "../../core/inputs/CoreAutoComplete";
import AsyncSelect from "react-select/async";
import { masterDataLoadOptions } from "../../store/actions/manageDataAction";
import CoreAsyncSelect from "../../core/inputs/CoreAsyncSelect";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 1000,
  maxHeight: 570,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  overflowY: "auto",
};

export default function MasterDataAddModal({ show, onClose, parentId }) {
  const dispatch = useDispatch();

  const [open, setOpen] = useState(false);

  const [name, setName] = useState("");
  const [label, setLabel] = useState("");
  const [order, setOrder] = useState(0);
  const [_status, set_status] = useState(ENTITY_STATUS["active"]);
  const [newParentId, setNewParentId] = useState(parentId);
  const [value, setValue] = useState("");

  useEffect(() => {
    setOpen(show);
  }, [show]);

  const onSubmit = (extraInfo) => {
    dispatch(
      api_request(
        API_METHOD_POST,
        `/data/MasterData/insert`,
        {
          name,
          label,
          order,
          _status,
          parentId: newParentId,
          value,
          extraInfo,
        },
        null,
        null,
        INSERT_TABLE_DATA_SUCCESS,
        INSERT_TABLE_DATA_ERROR,
        true,
        false,
        true
      )
    );
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <Grid container spacing={4}>
          <Grid item xs={6}>
            <Grid container spacing={4}>
              <Grid item xs={6}>
                <CoreInput
                  label="name"
                  value={name}
                  onChange={(e) => {
                    setName(e.target.value);
                  }}
                />
              </Grid>
              <Grid item xs={6}>
                <CoreInput
                  label="label"
                  value={label}
                  onChange={(e) => {
                    setLabel(e.target.value);
                  }}
                />
              </Grid>
              <Grid item xs={6}>
                <CoreInput
                  label="order"
                  value={order}
                  type="number"
                  onChange={(e) => {
                    setOrder(e.target.value);
                  }}
                />
              </Grid>
              <Grid item xs={6}>
                <CoreAutoComplete
                  onChange={(id, val) => {
                    set_status(val?.value);
                  }}
                  style={{ width: "100%" }}
                  value={_status}
                  options={Object.keys(ENTITY_STATUS).map((item) => {
                    return {
                      value: ENTITY_STATUS[item],
                      label: ENTITY_STATUS[item],
                    };
                  })}
                  label="_status"
                />
              </Grid>
              <Grid item xs={6}>
                <CoreAsyncSelect
                  display={(item) => {
                    return { value: item.id, label: item.name + "|" + item.id };
                  }}
                  value={newParentId}
                  onChange={(selectedOption) => {
                    setNewParentId(selectedOption?.value);
                  }}
                  valueColumn="id"
                  reducerVar="searchResults"
                  apiPath="/data/MasterData"
                  query={{}}
                  loadType={null}
                  successType={FETCH_TABLE_DATA_SEARCH_SUCCESS}
                  errorType={null}
                  loading={true}
                />
                {/* <AsyncSelect
                  label="parentId"
                  cacheOptions
                  defaultOptions={searchResults.map((item) => {
                    return {
                      value: item.id,
                      label: item.name + " | " + item.id,
                    };
                  })}
                  loadOptions={loadOptions}
                  value={{
                    value:
                      searchResults.find((f) => f.id === newParentId)?.name +
                      " | " +
                      searchResults.find((f) => f.id === newParentId)?.id,
                    label: searchResults.find((f) => f.id === newParentId)
                      ?.name,
                  }}
                  onChange={(selectedOption) => {
                    setNewParentId(selectedOption?.value);
                  }}
                  styles={{
                    control: (baseStyles, state) => ({
                      ...baseStyles,
                      height: "50px",
                    }),
                  }}
                /> */}
              </Grid>
              <Grid item xs={6}>
                <CoreInput
                  label="value"
                  value={value}
                  onChange={(e) => {
                    setValue(e.target.value);
                  }}
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={6}>
            <Grid container spacing={4}>
              <Grid item xs={12}>
                <CoreJsonEditor
                  height="225px"
                  value={{}}
                  onSubmit={(value) => {
                    onSubmit(value);
                  }}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </Modal>
  );
}
